import Icon from '../components/Icon.vue'

Icon.register({
  paste: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M128 184v232h-104c-13.3 0-24-10.7-24-24v-336c0-13.3 10.7-24 24-24h80.6c11.1-19.1 31.8-32 55.4-32s44.3 12.9 55.4 32h80.6c13.3 0 24 10.7 24 24v72h-136c-30.9 0-56 25.1-56 56zM160 40c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM344 288h104v200c0 13.3-10.7 24-24 24h-240c-13.3 0-24-10.7-24-24v-304c0-13.3 10.7-24 24-24h136v104c0 13.2 10.8 24 24 24zM448 249.9v6.1h-96v-96h6.1c5.5 0 13.1 3.1 17 7l65.9 65.9c3.9 3.9 7 11.5 7 17z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/paste.js
// module id = 1613
// module chunks = 0